/** Official UN SDG display names (goals 1–17). */
export const SDG_DISPLAY_NAMES: Record<number, string> = {
  1: 'No Poverty',
  2: 'Zero Hunger',
  3: 'Good Health and Well-being',
  4: 'Quality Education',
  5: 'Gender Equality',
  6: 'Clean Water and Sanitation',
  7: 'Affordable and Clean Energy',
  8: 'Decent Work and Economic Growth',
  9: 'Industry, Innovation and Infrastructure',
  10: 'Reduced Inequalities',
  11: 'Sustainable Cities and Communities',
  12: 'Responsible Consumption and Production',
  13: 'Climate Action',
  14: 'Life Below Water',
  15: 'Life on Land',
  16: 'Peace, Justice and Strong Institutions',
  17: 'Partnerships for the Goals',
};

export function getSdgDisplayName(sdgNumber: number): string | null {
  return SDG_DISPLAY_NAMES[sdgNumber] ?? null;
}

export function isSdgDisplayName(label: string): boolean {
  return Object.values(SDG_DISPLAY_NAMES).includes(label);
}

/** Reverse lookup: official SDG display name → goal number (1–17). */
export function getSdgNumberFromDisplayName(name: string): number | null {
  const trimmed = name.trim();
  for (const [num, display] of Object.entries(SDG_DISPLAY_NAMES)) {
    if (display === trimmed) return Number(num);
  }
  return null;
}
